var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2320_6403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.28638 19.9996C4.79065 19.9996 4.30325 19.8496 3.88667 19.558C3.67005 19.408 3.47843 19.2247 3.32012 19.0123L0.124957 14.7465C-0.0833328 14.4716 -0.0250116 14.08 0.249931 13.8717C0.524874 13.6634 0.916459 13.7217 1.12475 13.9967L4.32408 18.2624C4.40323 18.3666 4.49488 18.4582 4.60319 18.5332C4.8698 18.7165 5.19057 18.7873 5.50717 18.7332C5.82377 18.6749 6.10288 18.4999 6.28617 18.2333L18.8586 0.266188C19.0543 -0.0170865 19.4459 -0.0837392 19.7292 0.112053C20.0125 0.312012 20.0791 0.699431 19.8833 0.982705L7.31096 18.9456C6.93604 19.483 6.37366 19.8454 5.72796 19.9579C5.58215 19.9829 5.43635 19.9954 5.29055 19.9954L5.28638 19.9996Z",
    fill: "#71D1D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2320_6403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9958,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.c428c648e71fdb581925fe82fcb8ebc6.svg";
export { ForwardRef as ReactComponent };